module.exports = __webpack_public_path__ + "img/wangyigame.2aa4f586.jpg";